<template>
  <BaseSelect v-model="currentlySelectedOption" :options="selectArrayColumnOperators" :append-to-body="true"></BaseSelect>
  <BaseSelect
    v-if="arrayFilter.option === ArrayColumnOperators.CONTAINS_ANY"
    v-model="arrayValueInput"
    mode="tags"
    :placeholder="t('genericTable.arrayFilter.enterValues', { description: props.description })"
    :append-to-body="true"
    searchable
    :is-clearable="true"
    :create-option="true"
    :options="arrayValueInput"
  >
  </BaseSelect>

  <MissingValueFilter
    v-else-if="arrayFilter.option === CommonColumnOperators.VALUE_EXISTS"
    v-model="arrayFilter"
  ></MissingValueFilter>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import BaseSelect from "../../../../components/BaseSelect.vue";
import { ArrayColumnOperators, CommonColumnOperators } from "../../enum.filterOperators";
import { ArrayFilterType } from "../../type.genericTableQuery";
import MissingValueFilter from "./ValueExistsFilter.vue";
const arrayFilterType = defineModel<ArrayFilterType>({ required: true });
const arrayFilter = computed(() => arrayFilterType.value.filter);

const props = defineProps<{ description: string }>();
const { t } = useI18n();
const selectArrayColumnOperators = [
  { value: ArrayColumnOperators.CONTAINS_ANY, label: t("genericTable.arrayFilter.containsAny") },
  { value: CommonColumnOperators.VALUE_EXISTS, label: t("genericTable.valueExistsFilter.valueExists") },
];

const currentlySelectedOption = computed({
  get() {
    return arrayFilter.value.option;
  },
  set(newOption) {
    if (newOption !== arrayFilter.value.option) {
      arrayFilter.value.value = undefined;
      arrayFilter.value.option = newOption;
    }
  },
});

const arrayValueInput = computed({
  get: () => (Array.isArray(arrayFilter.value.value) ? arrayFilter.value.value : []),
  set: (val: string[]) => {
    arrayFilter.value.value = val.length === 0 ? undefined : val;
  },
});
</script>
